import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./api/auth";
import "./pwa-update"; // SW-päivitystarkistus etualalle palatessa + tunneittain (2.7.2026)
import "./styles/fonts.css"; // --font-ui (Inter) + --font-mono kaikille sivuille (16.10. / 19.10.2026)

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
